import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ROUTES } from '../Routes/routes';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../style/homepage.css';
import { Logo } from './header';

const footerLinks = {
  Company: ['About', 'Contact', 'Careers · coming soon'],
  Platform: ['For Dentists', 'For Labs', 'Book Demo'],
  Discover: ['Find a Dentist', 'FAQ', 'Blog coming soon'],
  Legal: ['Terms & Conditions', 'Refund Policy', 'Privacy Policy'],
};


export const ToothZapFooter: React.FC = () => {
  const navigate = useNavigate()

  return (
    <footer className="tz-footer">
      <div className="container tz-container">
        <div className="tz-footer-top">

          <div className="row mb-5 bdr-bottom">
            <div className="col-lg-12 col-md-8">
              <div className="tz-footer-brand">
                <Logo />
                <p className="tz-footer-text">
                  Same-day dental crown delivery infrastructure for dentists, milling labs, and patients
                  across New Delhi.
                </p>
              </div>
            </div>
          </div>


          <div className="row g-4 g-lg-5">


            {Object.entries(footerLinks).map(([cat, links]) => (
        <div className="col-6 col-md-4 col-lg-3" key={cat}>
                <p className="tz-footer-heading">{cat}</p>
                <ul className="list-unstyled mb-0">
                  {links.map((l) => (
                    <li key={l} className="tz-footer-item">
                      <a
                        href="/"
                        onClick={(e) => {
                          e.preventDefault();

                          if (l === 'About') {
                            navigate(ROUTES.AboutUs);
                          }
                          else if (l === 'Contact') {
                            navigate(ROUTES.Contact);
                          }
                          else if (l === 'For Dentists') {
                            navigate(ROUTES.Fordentist);
                          }
                          else if (l === 'For Labs') {
                            navigate(ROUTES.Forlabs);
                          }

                          else if (l === 'Book Demo') {
                            navigate(ROUTES.Bookdemo);
                          }
                          else if (l === 'Find a Dentist') {
                            navigate(ROUTES.Findadendtist);
                          }
                          else if (l === 'FAQ') {
                            navigate(ROUTES.Faq);
                          }
                          else if (l === 'Blog coming soon') {
                              return;
                          }
                          else if (l === 'Terms & Conditions') {
                            navigate(ROUTES.Termsandconditions);
                          }
                          else if (l === 'Refund Policy') {
                            navigate(ROUTES.RefundPolicy);
                          }
                          else if (l === 'Privacy Policy') {
                            navigate(ROUTES.PrivacyPolicy);
                          }


                        }}
                        className={`tz-footer-link ${l.includes('coming soon') ? 'tz-footer-link-muted' : ''
                          }`}
                      >
                        {l}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="tz-footer-bottom">
          <p className="tz-footer-bottom-text">
            ToothZap ·{' '}
            <a href="mailto:hello@toothzap.in" className="tz-footer-inline-link">
              hello@toothzap.in
            </a>{' '}
            · +91-00000-00000 · New Delhi, India
          </p>
          <p className="tz-footer-bottom-text">© 2026 ToothZap. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};